import validate from "/usr/src/app/content/n3-spas-1ec228be-1656-4fe9-bae3-9c864382ab2b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-1ec228be-1656-4fe9-bae3-9c864382ab2b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}